import { useField } from 'formik';
import { formatDate } from '@koob/dates';
import { useTranslation } from 'react-i18next';

const ConditionRecapField = ({ name, index, currency }) => {
  const { t } = useTranslation('cancellationPolicies', {
    keyPrefix: 'summary',
  });
  const [{ value }] = useField(`${name}.${index}`);
  const { deduction, isPercent, daysFrom, daysTo, period, numberOfNight } =
    value ?? {};

  const periodStart = period?.[0];
  const periodEnd = period?.[1];

  const hasRule =
    deduction !== undefined && daysFrom !== undefined && daysTo !== undefined;
  const hasPeriod = periodStart && periodEnd;

  if (!hasRule || !hasPeriod) return null;

  const baseKey = isPercent ? 'deductionPercentage' : 'deductionAmount';
  const translationKey = numberOfNight ? `${baseKey}WithNight` : baseKey;

  return (
    <div className="border border-gray-200 rounded-lg bg-gray-50 divide-y divide-gray-200">
      {hasRule && (
        <div className="flex justify-between items-center px-5 py-3">
          <span className="text-sm text-gray-500">{t('rule')}</span>
          <span className="text-sm font-medium text-red-500">
            {t(translationKey, {
              deduction,
              currency,
              daysFrom,
              daysTo,
              ...(numberOfNight && { numberOfNight }),
            })}
          </span>
        </div>
      )}
      {hasPeriod && (
        <div className="flex justify-between items-center px-5 py-3">
          <span className="text-sm text-gray-500">{t('applicablePeriod')}</span>
          <span className="text-sm font-medium text-gray-700">
            {formatDate(periodStart, 'MMM DD, YYYY')} –{' '}
            {formatDate(periodEnd, 'MMM DD, YYYY')}
          </span>
        </div>
      )}
    </div>
  );
};

export default ConditionRecapField;
